import { createPortal } from 'react-dom';
import styles from './Overlay.module.css';
import helpers from '../helpers.js';
const Overlay = ({ children, className = '', backdropClassName = '', portal = false }) => {
    const content = (
        <div className={helpers.clx(styles.overlayBg, backdropClassName)}>
            <div className={helpers.clx(styles.overlay, className)}>
                {children}
            </div>
        </div>
    );
    return portal ? createPortal(content, document.body) : content;
};

export default Overlay;
